export default __webpack_public_path__ + "static/media/prize-3-bm.010986cf.webp";